module.exports = __webpack_public_path__ + "static/media/s_34.4c25c831.mp3";